import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

import { settingsGroups } from "@/components/settings-groups";

export const Route = createFileRoute("/_authed/configuracoes/")({
  staticData: {
    title: "Configurações",
    subtitle: "Escolha o que você quer ajustar.",
  },
  component: ConfiguracoesHub,
});

/**
 * O hub: a lista de grupos.
 *
 * Uma linha por grupo, com a descrição do que mora lá dentro. A descrição não
 * é enfeite — é ela que evita a caça ao tesouro que a página única virou:
 * "quando o lembrete dispara" não está em nenhum rótulo de uma palavra, mas
 * está na descrição de "WhatsApp e bot".
 *
 * Linha inteira clicável e alta o bastante pro dedo (a área de toque vai do
 * ícone à seta), porque no celular esta é a tela de entrada de tudo que não
 * é o dia a dia.
 */
function ConfiguracoesHub() {
  return (
    <ul className="divide-y overflow-hidden rounded-lg border bg-card">
      {settingsGroups.map((group) => (
        <li key={group.to}>
          <Link
            to={group.to}
            className="flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-accent/60 sm:px-5"
          >
            <group.icon className="h-5 w-5 shrink-0 text-muted-foreground" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium">{group.label}</p>
              <p className="text-xs text-muted-foreground">{group.description}</p>
            </div>
            <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
          </Link>
        </li>
      ))}
    </ul>
  );
}
